import { JobExportContentFormat, JobStatus, JobType } from "@examspark/types";

export const ContentExportTypeMeta: Record<string, { label: string }> = {
  [JobExportContentFormat.ImsQtiV2P1Legacy]: {
    label: "QTI Version 2.1 (Legacy)",
  },
  [JobExportContentFormat.ImsQtiV2P1]: {
    label: "QTI Version 2.1",
  },
  [JobExportContentFormat.ImsQtiV2P2]: {
    label: "QTI Version 2.2",
  },
  [JobExportContentFormat.ImsQtiV3P0]: {
    label: "QTI Version 3.0",
  },
};

export const JobTypeMeta = {
  [JobType.ExportContent]: {
    label: "Content Export",
  },
  [JobType.ExportExamQti]: {
    label: "Exam Export (QTI)",
  },
  [JobType.ExportContentMetadata]: {
    label: "Metadata Report",
  },
  [JobType.ExportContentAlignments]: {
    label: "Alignment Report",
  },
  [JobType.ExportPassageMetadata]: {
    label: "Passage Report",
  },
  [JobType.TaskItemReport]: {
    label: "Task/Item Report",
  },
  [JobType.ExportAppUsers]: {
    label: "App User Report",
  },
  [JobType.ExportAppUsage]: {
    label: "App Usage Report",
  },
  [JobType.ImportContent]: {
    label: "Content Import",
  },
  [JobType.ExportObjectiveItemCounts]: {
    label: "Objective Count",
  },
  [JobType.RebuildLicense]: {
    label: "Rebuild Licenses",
  },
  [JobType.TestJob]: {
    label: "Test Job",
  },
  [JobType.ImportContentMetadata]: {
    label: "Content Metadata Import",
  },
};

export const JobStatusMeta = {
  [JobStatus.Pending]: {
    label: "Not Started",
  },
  [JobStatus.InProgress]: {
    label: "Not Started",
  },
  [JobStatus.CompleteFailure]: {
    label: "Failed",
  },
  [JobStatus.CompleteSuccess]: {
    label: "Succeeded",
  },
};
